<template>
  <div class="login">
    <div class="horizontal-layout horizontal-menu 1-column menu-expanded blank-page  pace-done">
      <div class="app-content content" id="app">
        <div class="content-wrapper">
          <div class="content-body">
            <section class="flexbox-container">
              <div class="col-12 d-flex align-items-center justify-content-center">
                <div class="col-md-4 col-10 box-shadow-2 p-0">
                  <div class="card border-grey border-lighten-3 m-0 p-3">
                    <div class="card-header border-0 pb-0">
                      <div class="card-title text-center">
                        <div class="p-1">
                          <h1>
                          <strong>{{$t('password_change_title')}}</strong>
                          </h1>
                        </div>
                      </div>
                    </div>
                    <div class="card-content">
                      <div class="card-body">
                        <div class="mb-2" v-if="errors.first('new_password1')">
                          <small class="text-danger d-block">{{ errors.first('new_password1') }}</small>
                        </div>
                        <div class="mb-2" v-if="errors.first('new_password2')">
                          <small class="text-danger d-block">{{ errors.first('new_password2') }}</small>
                        </div>
                        <form class="form-horizontal form-simple" @submit.prevent="doChangePassword">
                          <fieldset class="form-group position-relative has-icon-left mb-0">
                            <input type="password" name="new_password1" v-validate="'required|min:8'" @input="updateNewPassword1" class="form-control form-control-lg input-lg" v-bind:placeholder="$t('password_change_new_password1_label')" required="" aria-invalid="false">
                            <div class="form-control-position">
                                <i class="la la-key"></i>
                            </div>
                        </fieldset>
                        <fieldset class="form-group position-relative has-icon-left">
                            <input type="password" name="new_password2" v-validate="'required|min:8'" @input="updateNewPassword2" class="form-control form-control-lg input-lg" id="new_password2" v-bind:placeholder="$t('password_change_new_password2_label')" required="" aria-invalid="false">
                            <div class="form-control-position">
                                <i class="la la-key"></i>
                            </div>
                          </fieldset>
                          <button class="btn btn-info round btn-lg btn-block">
                            <i class="ft-unlock"></i> {{$t('password_recovery_btn')}}
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    changePasswordErrors () {
      return this.$store.state.changePassword.errors
    }
  },
  methods: {
    updateNewPassword1 (e) {
      this.$store.state.newPassword1 = e.target.value
    },
    updateNewPassword2 (e) {
      this.$store.state.newPassword2 = e.target.value
    },
    doChangePassword () {
      const data = {
        cmd: 'change_password',
        uidb64: this.$route.params.uidb64,
        token: this.$route.params.token,
        new_password1: this.$store.state.newPassword1,
        new_password2: this.$store.state.newPassword2
      }
      this.$socket.send(data)
    }
  },
  watch: {
    'changePasswordErrors' (oldValue, newValue) {
      if (newValue.length > 0) {
        const field = this.$validator.fields.find({ name: 'new_password2' })

        this.$validator.errors.add({
          'id': field.id,
          'field': field.name,
          'scope': field.scope,
          'msg': this.$t(newValue[0]),
          'rule': 'required'
        })
      } else {
        this.$router.push({
          path: '/login'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
body {
  background-color: red !important;
}
.form-simple fieldset  input[type="password"] {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.form-simple fieldset + fieldset input[type="password"] {
  border-bottom-left-radius: .35rem;
  border-bottom-right-radius: .35rem;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
